import { render, staticRenderFns } from "./CardListBuilder.vue?vue&type=template&id=d08502ac&scoped=true&"
import script from "./CardListBuilder.vue?vue&type=script&lang=js&"
export * from "./CardListBuilder.vue?vue&type=script&lang=js&"
import style0 from "./CardListBuilder.vue?vue&type=style&index=0&id=d08502ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08502ac",
  null
  
)

export default component.exports